import { Link } from 'react-router-dom';

export interface ToolLinkItem {
  icon: string;
  iconBg: string;
  title: string;
  subtitle: string;
  to: string;
  badge?: string;
}

export function ToolSection({ title, items }: { title: string; items: ToolLinkItem[] }) {
  return (
    <div>
      <p className="section-label">{title}</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {items.map((item) => (
          <Link
            key={item.to + item.title}
            to={item.to}
            className="card-hover flex items-start gap-3 p-4"
          >
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-lg ${item.iconBg}`}
            >
              {item.icon}
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2">
                <span className="block text-sm font-bold text-gray-900">{item.title}</span>
                {item.badge ? (
                  <span className="bg-primary-100 text-primary-700 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase">
                    {item.badge}
                  </span>
                ) : null}
              </span>
              <span className="mt-0.5 block text-xs text-gray-500">{item.subtitle}</span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
